/* eslint-disable */
export default {
  _background: 'background',
  _candy_box_cover: 'candy_box_cover',
  _candy_box: 'candy_box',
  _rounded_rect: 'rounded_rect',
  _go_button: 'go_button',
  _chocolate7: 'chocolate7',
  _chocolate_hole7: 'chocolate_hole7',
  _chocolate1: 'chocolate1',
  _chocolate_hole2: 'chocolate_hole2',
  _chocolate6: 'chocolate6',
  _chocolate_hole6: 'chocolate_hole6',
  _chocolate_hole12: 'chocolate_hole12',
  _chocolate_hole9: 'chocolate_hole9',
  _chocolate9: 'chocolate9',
  _chocolate12: 'chocolate12',
  _chocolate11: 'chocolate11',
  _chocolate_hole11: 'chocolate_hole11',
  _chocolate3: 'chocolate3',
  _chocolate4: 'chocolate4',
  _chocolate_hole3: 'chocolate_hole3',
  _chocolate_hole4: 'chocolate_hole4',
  _chocolate5: 'chocolate5',
  _chocolate_hole5: 'chocolate_hole5',
  _chocolate13: 'chocolate13',
  _chocolate2: 'chocolate2',
  _chocolate_hole1: 'chocolate_hole1',
  _chocolate_hole13: 'chocolate_hole13',
  _chocolate10: 'chocolate10',
  _chocolate_hole10: 'chocolate_hole10',
  _chocolate8: 'chocolate8',
  _chocolate_hole8: 'chocolate_hole8',
  _chocolate_particle: 'chocolate_particle',
}